import { StateEffect, StateField } from "@codemirror/state";
import { Decoration, EditorView } from "@codemirror/view";

export const syntaxErrorMark = Decoration.mark({
  attributes: { style: "text-decoration: underline; color: red;" },
});

export const addSyntaxError = StateEffect.define({
  map: ({ from, to }, change) => ({
    from: change.mapPos(from),
    to: change.mapPos(to),
  }),
});

export const removeSyntaxError = StateEffect.define();

// extension to manage syntax error marks in editor
export const syntaxErrorFieldExtension = StateField.define({
  create() {
    return Decoration.none;
  },
  update(syntaxErrors, tr) {
    /* eslint-disable no-param-reassign */
    syntaxErrors = syntaxErrors.map(tr.changes);

    // eslint-disable-next-line no-restricted-syntax
    for (const effect of tr.effects) {
      if (effect.is(addSyntaxError)) {
        syntaxErrors = syntaxErrors.update({
          add: [syntaxErrorMark.range(effect.value.from, effect.value.to)],
        });
      } else if (effect.is(removeSyntaxError)) {
        syntaxErrors = syntaxErrors.update({ filter: effect.value });
      }
    }

    return syntaxErrors;
  },
  provide: (field) => EditorView.decorations.from(field),
});
